/**
 * Routes Configuration
 * Centralized route definitions for the application
 */

export const ROUTES = {
  HOME: "/",
  CHAT: "/chat",
  CONVERSATION: (
    conversationId: string,
    platform?: string,
    accountId?: string
  ) => {
    if (platform && accountId) {
      return `/conversations/${platform}/${accountId}/${conversationId}`;
    }
    return `/conversations/${conversationId}`;
  },
  SETTINGS: {
    BASE: "/settings",
    GENERAL: "/settings/general",
    NOTIFICATION: "/settings/notification",
    PRIVACY: "/settings/privacy",
    ACCOUNT: "/settings/account",
    FACEBOOK_TEMPLATES: "/settings/facebook-templates",
    FACEBOOK_TEMPLATE_CREATE: "/settings/facebook-templates/create",
    FACEBOOK_TEMPLATE_EDIT: (id: number) => `/settings/facebook-templates/${id}`,
  },
} as const;
